import ZfWebchat, {
  useCreateBotStore,
  botStore,
  ThemeTypes,
  getWithExpiry,
  setWithExpiry,
  language,
  restart,
  setTheme,
} from "@zf/react-frontend-vite";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { apiTokenRequest } from "./authConfig.js";
import Login from "./Login";
import chatIcon from "./ChatIcon.png";
import avatar from "./bot-logo.png";
import LoadingIcon from "./customComponents/LoadingIcon";
import RaiseTicketComponent from "./customComponents/RaiseTicketComponenet";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import "./App.css";
import useFromChange from "./hooks/useFromChange";
import useCustomEvents from "./hooks/useCustomEvents";
import useButtonTimeout from "./hooks/useButtonTimeout";
import useAttachmentButton from "./hooks/useAttachmentButton";
import useCheckAgent from "./hooks/useCheckAgent";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { IconButton } from "@mui/material";
import useUniversalAssetPickerChange from "./hooks/useUniversalAssetPickerChange";
import { useReplaceDropdowns } from "./hooks/useReplaceDropdowns";
import { useInputValidation } from "./hooks/useInputValidation";
import useSendDisconnect from "./hooks/useSendDisconnect.js";

const greeting = {
  en: "Hi! How can I help you?",
  de: "Hallo! Wie kann ich dir helfen?",
};

const checkParams = () => {
  const url =
    window.location != window.parent.location
      ? document.referrer
      : document.location.href;
  const arr = url.split("?");
  if (
    arr.length > 1 &&
    arr[1] !== "" &&
    (arr[1].includes("question") || arr[1].includes("worflow"))
  ) {
    return true;
  }
  return false;
};

function getColonParam(paramName) {
  // Get the query string without the leading "?"
  const query = window.location.search.substring(1);

  if (!query) return undefined;

  // Split into pairs by "&"
  const pairs = query.split("&");

  for (const pair of pairs) {
    const [key, value] = pair.split(":");
    if (key === paramName) {
      return value; // Return value if key matches
    }
  }

  return undefined; // Return undefined if not found
}

function App() {
  const { accounts, inProgress, instance } = useMsal();
  const [storeAction, setStoreAction] = useState();
  const [attButton, setAttButton] = useState(false);
  const [changeForm, setChangeForm] = useState();
  const [changeCPlace, setCPlace] = useState(false);
  const [assetOptionClicked, setOptionClicked] = useState();
  const [changeUniversalAssetPicker, setUniversalAssetPicker] = useState(false);
  const [assetPickerOptions, setAssetPickerOptions] = useState([]);
  const [token, setToken] = useState();

  const [checked, setChecked] = useState(() => {
    /*if (checkParams()) {
      setWithExpiry("is_agent", false);
      return false;
    }
    return getWithExpiry("is_agent");*/
    return false;
  });
  const [endpoint, setEndpoint] = useState(() => {
    return {
      bot: process.env.REACT_APP_ENDPOINT,
      dle: process.env.REACT_APP_DLE,
    };

    /*if (checkParams()) {
      setWithExpiry("is_agent", false);
      return {
        bot: process.env.REACT_APP_ENDPOINT,
        dle: process.env.REACT_APP_DLE,
      };
    }
    return getWithExpiry("is_agent")
      ? {
          bot: process.env.REACT_APP_ENDPOINT_AGENT,
          dle: process.env.REACT_APP_DLE_AGENT,
        }
      : {
          bot: process.env.REACT_APP_ENDPOINT,
          dle: process.env.REACT_APP_DLE,
        };*/
  });
  const botProps = botStore.getState();

  useEffect(() => {
    if (accounts.length === 0) return;
    const getToken = async () => {
      const tokenResponse = await instance.acquireTokenSilent({
        ...apiTokenRequest,
        account: accounts[0],
      });
      setToken(tokenResponse.accessToken);
    };
    getToken();
  }, [botProps.connectionReducer.restart, accounts.length]);

  const [disabled, setDisabled] = useState(false);

  const customStore = useCreateBotStore(
    getColonParam("langOverride") ||
      navigator.language ||
      navigator.userLanguage ||
      "en",
    setStoreAction,
    true,
    ["isAgent"],
  );
  const bubbles = document.getElementsByClassName(
    "webchat__stacked-layout__content",
  );

  useSendDisconnect(botStore);
  useCustomEvents(
    storeAction,
    setAttButton,
    setChangeForm,
    setCPlace,
    botStore,
    attButton,
    setUniversalAssetPicker,
    setAssetPickerOptions,
  );
  useFromChange(
    bubbles,
    changeForm,
    setChangeForm,
    botProps,
    assetOptionClicked,
    assetPickerOptions,
    setOptionClicked,
  );
  useButtonTimeout(bubbles);
  useAttachmentButton(attButton, customStore);
  useReplaceDropdowns(
    changeCPlace,
    changeUniversalAssetPicker,
    changeForm,
    setOptionClicked,
    bubbles,
  );
  useUniversalAssetPickerChange(
    bubbles,
    changeUniversalAssetPicker,
    setUniversalAssetPicker,
    assetOptionClicked,
    changeCPlace,
    setCPlace,
    assetPickerOptions,
    setOptionClicked,
  );
  const isAgent = useCheckAgent();
  useInputValidation();
  //const switchDisabled = useAgentSlider(checked, botProps, bubbles, setChecked);
  const handleChange = (event) => {
    const isAgent = event.target.checked;
    setWithExpiry("is_agent", isAgent);
    setDisabled(true);
    //botStore.dispatch(restart());
    setChecked(isAgent);
    setEndpoint(
      isAgent
        ? {
            bot: process.env.REACT_APP_ENDPOINT_AGENT,
            dle: process.env.REACT_APP_DLE_AGENT,
          }
        : {
            bot: process.env.REACT_APP_ENDPOINT,
            dle: process.env.REACT_APP_DLE,
          },
    );
    setTimeout(() => setDisabled(false), 2000);
  };

  const handleHelpLink = () => {
    window.open(
      isAgent && checked
        ? process.env.REACT_APP_AGENT_HELP_URL
        : process.env.REACT_APP_HELP_URL,
      "_blank",
    );
  };

  const getHelpTooltip = () => {
    if (isAgent && checked) {
      return botProps.connectionReducer.language === "de"
        ? "Agent-Bot-Benutzerhandbuch"
        : "Agent-Bot usage manual";
    }
    return botProps.connectionReducer.language === "de"
      ? "IT-HelpBot-Benutzerhandbuch"
      : "IT-HelpBot usage manual";
  };

  if (inProgress !== "none") {
    return (
      <div className="app-loading">
        <div className="app-loading-spinner"></div>
      </div>
    );
  }

  return (
    <>
      <ZfWebchat
        title={
          process.env.REACT_APP_TITLE + (isAgent && checked ? " - Agent" : "")
        }
        endpoint={endpoint.bot}
        msalToken={token}
        languages={isAgent && checked ? ["en", "de"] : undefined}
        allowLanguageSelection
        allowReactionButtons
        dleIncluded={false}
        allowDataProtectionPrompt={false}
        enableLogout={false}
        isAgent={checked}
        loadBot={token ? true : false}
        chatComponents={!token ? [<Login />] : undefined}
        //dle={endpoint.dle}
        enableRegionalToken={!checked}
        regionalDomain={process.env.REACT_APP_REGIONAL_DOMAIN}
        fullPageApp={process.env.REACT_APP_FULLPAGE === "true"}
        customBotIconPath={chatIcon}
        customAvatarPath={avatar}
        anchorClass={
          isAgent && checked
            ? botProps.screenReducer.theme === ThemeTypes.LIGHT
              ? "userstatus_agent"
              : "userstatus_agent-dark"
            : undefined
        }
        headerComponents={[
          <Tooltip title={getHelpTooltip()}>
            <IconButton onClick={handleHelpLink} className="helpButton">
              <HelpOutlineIcon className="helpIcon" />
            </IconButton>
          </Tooltip>,
          isAgent ? (
            <Tooltip title={`Current mode: ${checked ? "Agent" : "User"}`}>
              <Switch
                defaultChecked
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
              />
            </Tooltip>
          ) : undefined,
        ]}
        customStore={customStore}
        defaultLanguage={
          getColonParam("langOverride") ||
          (navigator.language || navigator.userLanguage)?.slice(0, 2)
        }
        welcomeMessage={
          (navigator.language || navigator.userLanguage)?.slice(0, 2) === "de"
            ? greeting.de
            : greeting.en
        }
        messageComponent={[
          <>
            {
              <RaiseTicketComponent
                workflowName={"EngineeringRequest"}
                buttonText={{
                  de: "Engineering-Ticket erstellen",
                  en: "Create Engineering Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"EngineeringRequest"}
                buttonText={{
                  de: "Engineering",
                  en: "Engineering",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"SAPRequest"}
                buttonText={{
                  de: "SAP-Ticket erstellen",
                  en: "Create SAP Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"SAPRequest"}
                buttonText={{
                  de: "SAP",
                  en: "SAP",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"QADRequest"}
                buttonText={{
                  de: "IT-Unterstützung bei QAD Problemen",
                  en: "Create QAD Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"QADRequest"}
                buttonText={{
                  de: "QAD",
                  en: "QAD",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"AS400Request"}
                buttonText={{
                  de: "IT-Unterstützung bei AS400 Problemen",
                  en: "Create AS400 Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"AS400Request"}
                buttonText={{
                  de: "AS400",
                  en: "AS400",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"EDIRequest"}
                buttonText={{
                  de: "EDI-Ticket erstellen",
                  en: "Create EDI Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"EDIRequest"}
                buttonText={{
                  de: "EDI",
                  en: "EDI",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"JISRequest"}
                buttonText={{
                  de: "IT-Unterstützung bei JIS Problemen",
                  en: "Create JIS Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"JISRequest"}
                buttonText={{
                  de: "JIS",
                  en: "JIS",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"ProductionApplicationRequest"}
                buttonText={{
                  de: "IT-Unterstützung bei Production Application Problemen",
                  en: "Create Production Application Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"ProductionApplicationRequest"}
                buttonText={{
                  de: "Produktions-Anwendung",
                  en: "Production Application",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"ComplaintRequest"}
                buttonText={{
                  de: "Eine IT bezogene Beschwerde erstellen",
                  en: "IT-complaint",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"ComplaintRequest"}
                buttonText={{
                  de: "IT-Beschwerde",
                  en: "IT-Complaint",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"OthersRequest"}
                buttonText={{
                  de: "Ticket erstellen",
                  en: "Create Ticket",
                }}
              />
            }
          </>,
          <>
            {
              <RaiseTicketComponent
                workflowName={"OthersRequest"}
                buttonText={{
                  de: "Andere (d.h. Service nicht gelistet)",
                  en: "Others (i.e. Services not listed)",
                }}
              />
            }
          </>,
        ]}
        messageComponentConditions={[
          "engineering",
          "engineeringshort",
          "sap",
          "sapshort",
          "qad",
          "qadshort",
          "as400",
          "as400short",
          "edi",
          "edishort",
          "jis",
          "jisshort",
          "production",
          "productionshort",
          "itcomplaint",
          "itcomplaintshort",
          "other",
          "othershort",
        ]}
      />
    </>
  );
}

export default App;
